<template>
  <div class="wrapperIcon">
    <slot></slot>
  </div>
</template>

<script setup></script>

<style lang="scss">
.wrapperIcon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background: url('../imgs/icon-border.svg') center center/cover no-repeat;
  transform: translateY(-15%);
  svg {
    stroke: grey;
    margin-top: -3px;
    margin-left: -2px;
  }
}
</style>
